import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, Chip, ListItemText, MenuItem, OutlinedInput, Select, Tooltip, Typography } from "@mui/material";
import { useStyles } from "./UserClustersAccess.styles";
import { IUserClustersAccess } from "./UserClustersAccessInterfaces";

const itemHeight = 48;
const itemPaddingTop = 8;
const menuProps = {
    PaperProps: {
        style: {
            maxHeight: itemHeight * 4.5 + itemPaddingTop,
            width: 250,
        },
    },
};

const UserClustersAccess = ({ clusters, values, setFieldValue, user, disabled }: IUserClustersAccess) => {
    const classes = useStyles();
    const { t } = useTranslation();
    useEffect(() => {
        if (user && user.user_clusters) {
            const clustersIds = user.user_clusters.map((cluster) => cluster.cluster.cluster_id);
            setFieldValue("userClusters", clustersIds);
        }
    }, [setFieldValue, user]);
    return (
        <div className={classes.selectCluster}>
            <span className={classes.selectClusterTitle}>
                {t("locations.user_tab.add_user.select_cluster_access")}:
            </span>
            <div className={classes.selectClusterContent}>
                <Select
                    fullWidth
                    disabled={disabled}
                    className={classes.select}
                    labelId="user-cluster-label"
                    id="user-cluster-chip"
                    multiple
                    value={values.userClusters || []}
                    input={<OutlinedInput id="user-cluster-select" />}
                    renderValue={(selected) => (
                        <Box className={classes.box}>
                            {selected.map((value) => (
                                <Chip
                                    key={value}
                                    label={clusters.find((cluster) => cluster.cluster_id === value)?.name}
                                />
                            ))}
                        </Box>
                    )}
                    MenuProps={menuProps}
                >
                    {clusters.map((cluster) => (
                        <MenuItem key={cluster.cluster_id} value={cluster.cluster_id} className={classes.menuItem}>
                            <Checkbox
                                color="info"
                                checked={values.userClusters.includes(cluster.cluster_id)}
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const clusterId = cluster.cluster_id;
                                    if (isChecked) {
                                        setFieldValue("userClusters", [...values.userClusters, clusterId]);
                                    } else {
                                        setFieldValue(
                                            "userClusters",
                                            values.userClusters.filter((id) => id !== clusterId),
                                        );
                                    }
                                }}
                            />{" "}
                            <Tooltip
                                placement="top"
                                PopperProps={{
                                    className: classes.tooltip,
                                }}
                                title={
                                    <Typography className={classes.tooltipTexts}>
                                        {clusters
                                            .find((clusterItem) => clusterItem.cluster_id === cluster.cluster_id)
                                            ?.machine_centers.map((machineCenter) => (
                                                <span
                                                    key={machineCenter.machine_center_id}
                                                    style={{ display: "block" }}
                                                >
                                                    {machineCenter.name}
                                                </span>
                                            ))}
                                    </Typography>
                                }
                            >
                                <ListItemText>{cluster.name}</ListItemText>
                            </Tooltip>
                        </MenuItem>
                    ))}
                </Select>
            </div>
        </div>
    );
};

export default UserClustersAccess;
